;(function() {
  'use strict'

  service.$inject = ["$log", "$q", "modulesResource"];
  angular.module('core.services').factory('moduleService', service)

  /* @ngInject */
  function service($log, $q, modulesResource) {
    var log = $log.create('moduleService')

    return {
      getByPage: getByPage,
    }

    function getByPage(pageId) {
      return $q(function(resolve, reject) {
        modulesResource
          .get({ pageId: pageId })
          .success(function(resources, modules) {
            modules = transformModules(modules)
            resolve(modules)
          })
          .error(function(response, status) {
            reject({
              response: response,
              status: status,
            })
          })
      })
    }

    function transformModules(response) {
      var modules = {}
      _.each(response, function(module) {
        if (modules[module.type]) {
          log.error(
            'duplicate module type (' +
              module.type +
              ') for page (' +
              module.page +
              ')'
          )
        }
        modules[module.type] = module
      })
      return modules
    }
  }
})()
